import type { ValidationResponseMessage } from './common';

export interface CreateBackgroundJobResult {
  backgroundJobId: number;
  backgroundJobStatusEndpoint: string;
}

export interface BackgroundJobDetailsResult {
  id: number;
  archived: boolean;
  status: string;
  createdDate: string;
  startDate: string;
  finishDate?: string;
  jobDetails?: string;
  userId: number;
  type: string;
  responseErrors?: ValidationResponseMessage[];
  hasRecordsToImport?: boolean;
}

export interface CreateImportJobResult extends BackgroundJobDetailsResult {
  presignedUrl: string;
}

export interface FullRecordDataExportJobResultProps extends CreateExportJobResult {
  presignedUrl: string;
}

export interface CreateExportJobResult extends CreateBackgroundJobResult {
  exportFileUrl: string;
}

export interface StartImportJobApiProps {
  id: number;
  options_import_mode?: number;
  time_zone?: string;
  send_record_notifications?: string;
}

export interface StartImportJobApiArgs {
  jobId: number;
  prefix?: 'RECORD_ID' | 'RECORD_SOURCE_ID';
}

export interface ExportSingleRecordJobResult extends CreateBackgroundJobResult {
  description: string;
}

export interface ExportRecordFieldJobResult extends CreateBackgroundJobResult {
  exportFileUrl: string;
  description: string;
}

export interface CloneRecordsJobResult extends CreateBackgroundJobResult {
  description: string;
}

export type StartAnalysisJobApiResponse = {
  message: string;
  backgroundJobId: number;
};

export type StartAnalysisJobApiArg = {
  extraPrompt?: string;
  moduleId: string;
  formId?: string;
  body: {
    file: Blob;
  };
};

export interface AnalysisJobResult {
  inferred_context?: string;
  data_quality_notes?: string;
  patterns_and_insights?: string[];
  analysis?: Record<string, unknown>;
}

export interface GetAnalysisJobStatusApiResponse {
  status: string;
  result?: AnalysisJobResult;
}

export type MutateRecordBackgroundJobResult = BackgroundJobDetailsResult;

export interface BackgroundJobsItem {
  id: number;
  archived: boolean;
  status: string;
  createdDate: string;
  startDate: string;
  finishDate: string;
  moduleFormId: number;
  type: number;
  fileName?: string;
  presignedUrl?: string;
  parentRecordTitle?: string;
  clonedRecordIds?: string;
}

export interface BackgroundJobsResult {
  availablePages: number;
  items?: BackgroundJobsItem[];
  page: number;
  size: number;
  totalSize: number;
}

export interface BackgroundJobsApiProps {
  type: string;
  page?: number;
  pageSize?: number;
}

export const apiJobTypes = {
  RECORD_IMPORT: 1,
  RECORDLIST_EXPORT: 2,
  CLONE_RECORD: 3,
  ATTACHMENT_IMPORT: 4,
  BOWTIE_RECORDS_CREATION: 5,
  RECORD_CREATE: 6,
  RECORD_UPDATE: 7,
  FULL_RECORDS_EXPORT: 8,
  RECORD_EXPORT: 9,
  RECORD_FIELD_EXPORT: 10,
};
